import Appartment from "images/appartment.svg";
import Building from "images/building.svg";
import House from "images/house.svg"; 
import { RewardManagementContext } from '../context/RewardManagementContext';
import React , { useRef, useContext,useState }  from "react";
import Moment from 'react-moment'
 
import { ModalUpgrade, ModalClaim, ModalTransfer } from ".";
import { Loader } from ".";
import Web3 from "web3";

const Transactions = () =>{
    
    const web3 = new Web3(window.ethereum);
    const {allModule, getNodeFee } = useContext(RewardManagementContext);
    const [showModalClaim, setShowModalClaim] = useState(false);
    const [showModalUpgrade, setShowModalUpgrade] = useState(false);
    const [showModalTransfer, setShowModalTransfer] = useState(false);

    
    const initialValue = { blockTime: "", rewardAmount: "3.00", totalFee:"2.00", totalRewards:"0.00", currentTier:"0", nextTier: "0"};
    const [formValues, setFormValues] = useState(initialValue);
    //console.log(allModule);

    const openModalClaim = (createTime, rewardAmount) => {
      
      setFormValues({...formValues, blockTime: createTime, rewardAmount : rewardAmount });
      

      const tfee = getNodeFee(createTime, rewardAmount).then((fee) => {
           //setcurrFee(f);
           console.log('fee',fee);

          setFormValues({...formValues, blockTime: createTime, 
            rewardAmount : Number(web3.utils.fromWei(rewardAmount)).toFixed(9),
            totalFee:Number(web3.utils.fromWei(fee)).toFixed(9),
            totalRewards : (Number(web3.utils.fromWei(rewardAmount)).toFixed(9) - Number(web3.utils.fromWei(fee)).toFixed(9) )
          });
          setShowModalClaim((prev) => !prev);

         });
      
    };


    const openModalUpgrade = (createTime, rewardAmount, currentTier) => { 


      let currentTierName = "";
      let nextTierName = "";
      let nextTier = Number(currentTier) + 1;
        
      switch (currentTier) {
        case "0":
          currentTierName = "Appartment";
          break;
        case "1":
          currentTierName = "Building";
          break;
        case "2":
          currentTierName = "House";
          break;
        case "3":
          currentTierName = "Villa";
          break;
      }

      switch (nextTier) {
        case 0:
          nextTierName = "Appartment";
          break;
        case 1:
          nextTierName = "Building";
          break;
        case 2:
          nextTierName = "House";
          break;
        case 3:
          nextTierName = "Villa";
          break;
      }

      

      setFormValues({...formValues, blockTime: createTime, 
        rewardAmount : rewardAmount, 
        currentTier:currentTierName,
        nextTier: nextTierName,});

         setShowModalUpgrade((prev) => !prev);
      
    };

    const openModalTransfer = (createTime, rewardAmount) => { 
      setFormValues({...formValues, blockTime: createTime, rewardAmount : rewardAmount }); 
         setShowModalTransfer((prev) => !prev);
      
    };


    //const i = 0;
    return(
        <div className="w-full flex md:justify-center justify-between items-center flex-col p-4 gradient-bg-footer">
        <ModalClaim showModalClaim={showModalClaim} setShowModalClaim={setShowModalClaim} formValues={formValues} setFormValues={setFormValues} />
        <ModalUpgrade showModalUpgrade={showModalUpgrade} setShowModalUpgrade={setShowModalUpgrade} formValues={formValues} setFormValues={setFormValues} />
        <ModalTransfer showModalTransfer={showModalTransfer} setShowModalTransfer={setShowModalTransfer} formValues={formValues} setFormValues={setFormValues} />
        <div className="bg-black text-center rounded-lg p-4 shadow-xl text-white flex flex-row">
        <div className="flex flex-col">
  <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
    <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
      <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
      

        <table className="min-w-full divide-y divide-[#303336]">
          <thead className="bg-[#303336]">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#b4bcbf] uppercase tracking-wider">Module Name</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#b4bcbf] uppercase tracking-wider">Created</th>
              {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#b4bcbf] uppercase tracking-wider">Status</th> */}
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#b4bcbf] uppercase tracking-wider">Reward</th>
              {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#b4bcbf] uppercase tracking-wider">Fee</th> */}
              <th scope="col" className="relative px-6 py-3">
                <span className="sr-only"></span>
              </th>
              <th scope="col" className="relative px-6 py-3">
                <span className="sr-only">Claim</span>
              </th>
              <th scope="col" className="relative px-6 py-3">
                <span className="sr-only">Upgrad</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-[#595e61] divide-y divide-[#303336]">
          {allModule[0]?.map((item) => (
            <tr key={item.id} >
              <td className="px-6 py-4 whitespace-nowrap text-left  ">
                <div className="flex items-center">
                  <div className="flex-shrink-0 h-10 w-10">
                    <img src={"images/" + item.mName + ".svg"} alt="logo" className="h-10 w-10 rounded-full cursor-pointer " style={{ color: "white" }} />
                  </div>
                  <div className="ml-4 text-left">
                    <div className="text-sm font-medium text-white text-[#b4bcbf]">{item.nodeName}</div>
                    {/* <div className="text-sm text-gray-500">{item.nodeName}</div> */}
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-[#b4bcbf]"><Moment unix>{item.createTime}</Moment></div>
                {/* <div className="text-sm text-gray-500">Optimization</div> */}
              </td>
              {/* <td className="px-6 py-4 whitespace-nowrap">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-white text-green-800"> Active </span>
              </td> */}
              <td className="px-6 py-4 whitespace-nowrap text-sm text-[#b4bcbf]">{item.reward}</td>
              {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-[#b4bcbf] uppercase tracking-wider">0.0</th> */}
              <td className="px-0 py-4 whitespace-nowrap text-right text-sm font-medium">
              <div className="mt-0 mb-0 p-0 flex flex-row justify-end items-center rounded-md place-items-end">
                  <a className="btn "   onClick={() => openModalClaim(item.createTime, item.rewardAmount)}>
                    <span>Claim</span>
                  </a>
                </div>
                {/* <a href="#" class="text-indigo-600 hover:text-indigo-900">Pay fees</a> */}
              </td>
              <td className="px-0 py-4 whitespace-nowrap text-right text-sm font-medium">
                {/* <a href="#" className="text-indigo-600 hover:text-indigo-900">Claim</a> */}
                
                <div className= {(Number(item.tier) > 1) ? 'invisible': 'mt-0 mb-0 p-0 flex flex-row justify-end items-center rounded-md place-items-end'}>
                
                  <a className="btn " onClick={() => openModalUpgrade(item.createTime, item.rewardAmount, item.tier)} >
                    <span>Upgrade</span>
                  </a>
                

                </div>
              </td>

              <td className="px-0 py-4 whitespace-nowrap text-right text-sm font-medium">
                 
                <div className="mt-0 mb-0 p-0 flex flex-row justify-end items-center rounded-md place-items-end">
                  <a className="btn " onClick={() => openModalTransfer(item.createTime, item.rewardAmount)}    >
                    <span>Transfer</span>
                  </a>
                </div>
              </td>

            </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</div>
</div>
    );
}
export default Transactions;